import { Typography } from '@material-ui/core'
import { useState } from 'react'

import { ComLog } from '../../../types/monitoring'
import { redactSecrets } from '../../../utils/comlogRedaction'
import MonitoringFormViewMoreInfoModal from '../MonitoringFormViewMoreInfoModal'
import MonitoringRowMenu from '../MonitoringRowMenu'
import useStyles from './styles/MonitoringFormListRow.styles'

interface MonitoringFormListRowMobileProps {
  data: ComLog
}
/**
 * PMS integrations authenticate inside the message body — a Mosafer request
 * carries the property's SecurityPass and each channel's AgencyPass in
 * cleartext — so the raw payload is masked before it is shown. This screen
 * predates the redaction; it was exposing those values, and is fixed here
 * rather than left as the unredacted path beside a redacted one.
 */
const MonitoringFormListRowMobile: React.FC<
  MonitoringFormListRowMobileProps
> = ({ data }) => {
  const classes = useStyles()
  const [viewRequestIsOpen, setviewRequestIsOpen] = useState<boolean>(false)
  const [viewResponseIsopen, setviewResponseIsopen] = useState<boolean>(false)
  return (
    <div className={classes.root}>
      <div>
        <Typography variant="body1">
          {data.EndpointName.substr(data.EndpointName.indexOf('.'), 20)}
        </Typography>
      </div>
      <div>
        <Typography variant="body1">{data.Status}</Typography>
      </div>
      <div className={classes.moreIcon}>
        <MonitoringRowMenu
          viewRequest={() => setviewRequestIsOpen(true)}
          viewResponse={() => setviewResponseIsopen(true)}
        />
      </div>
      <MonitoringFormViewMoreInfoModal
        requestView={JSON.parse(redactSecrets(data.Request))}
        isOpen={viewRequestIsOpen}
        onClose={() => setviewRequestIsOpen(false)}
      />
      <MonitoringFormViewMoreInfoModal
        requestView={JSON.parse(redactSecrets(data.Response))}
        isOpen={viewResponseIsopen}
        onClose={() => setviewResponseIsopen(false)}
      />
    </div>
  )
}
export default MonitoringFormListRowMobile
